/* ---------------------------------------------------------------
   HEIDI — Panneau de confirmation d'action, 01/08/2026.

   Demande de Yann : « on clique mais rien ne nous informe de l'action effectuée ».
   Au doigt le panneau monte du bas, à la souris il se pose en haut à droite — la mise en
   page est entièrement dans le CSS, ce fichier ne fait que remplir et révéler.

   IL NE COUVRE PAS LE PANIER, ET C'EST MESURÉ. Un clic sur le bouton panier d'une carte
   pose déjà `body.cart-sidebar-show` et ouvre le tiroir d'Ella, compteur à jour : le
   retour existe. En ajouter un second ferait doublon. Le cœur et le devis, eux, n'avaient
   aucun retour visible — ce sont eux que ce panneau sert.

   AUCUN DÉPLACEMENT DU FOCUS, contrairement à la feuille de disponibilité. C'est une
   information, pas une boîte de dialogue : pas de voile, pas de piège de focus, pas de
   verrou de défilement. Cela lui évite au passage le défaut qui a obligé à exclure la
   recherche prédictive de la feuille — y déplacer le focus fait tomber le `:focus-within`
   qui tient le panneau plein écran ouvert.

   TOUT EST DÉLÉGUÉ AU DOCUMENT : les grilles sont re-rendues en AJAX à chaque filtre et
   slick clone ses diapositives.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var DUREE = 6000;
  var panneau = null;
  var minuteur = null;

  function refs() {
    panneau = document.querySelector('[data-hs-notice]');
    return !!panneau;
  }

  function texteCarte(carte) {
    if (!carte) return '';
    var t = carte.querySelector('.card-title');
    return t ? (t.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function imageCarte(carte) {
    if (!carte) return '';
    var i = carte.querySelector('.card-media img, img');
    if (!i) return '';
    // `currentSrc` donne l'image REELLEMENT choisie par le navigateur dans le srcset ;
    // `src` peut encore porter le pixel de chargement differe d'Ella.
    return i.currentSrc || i.getAttribute('src') || '';
  }

  function cache() {
    if (minuteur) { clearTimeout(minuteur); minuteur = null; }
    if (panneau) panneau.hidden = true;
  }

  /* opts : { type: 'wishlist' | 'quote', carte: Element, retire: bool } */
  function montre(opts) {
    if (!refs()) return;
    if (minuteur) { clearTimeout(minuteur); minuteur = null; }

    var type = opts.type;
    var msg = '';
    if (type === 'wishlist') {
      msg = panneau.getAttribute(opts.retire ? 'data-msg-wishlist-removed' : 'data-msg-wishlist-added');
    } else {
      msg = panneau.getAttribute('data-msg-quote-added');
    }

    var url = panneau.getAttribute('data-url-' + type) || '';
    var libelle = panneau.getAttribute('data-label-' + type) || '';

    var img = panneau.querySelector('[data-hs-notice-img]');
    var src = imageCarte(opts.carte);
    if (img) {
      if (src) { img.src = src; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
    }

    var nom = panneau.querySelector('[data-hs-notice-product]');
    if (nom) nom.textContent = texteCarte(opts.carte);

    var m = panneau.querySelector('[data-hs-notice-msg]');
    if (m) m.textContent = msg || '';

    var cta = panneau.querySelector('[data-hs-notice-cta]');
    if (cta) {
      // Un retrait de la liste d'envie n'appelle pas d'action : le lien disparaît.
      if (url && libelle && !opts.retire) {
        cta.href = url;
        cta.textContent = libelle;
        cta.hidden = false;
      } else {
        cta.hidden = true;
      }
    }

    panneau.hidden = false;
    minuteur = setTimeout(cache, DUREE);
  }

  window.hsNotice = { montre: montre, cache: cache };

  /* --- Le cœur d'Ella --------------------------------------------
     Ella n'émet aucun événement à l'ajout : elle bascule la classe `wishlist-added` sur
     le bouton. On lit donc l'état APRÈS son propre gestionnaire, d'où le report d'un
     tour de boucle — sans lui on lirait l'état d'avant le clic et le message serait
     systématiquement inversé. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    if (e.target.closest('[data-hs-notice-close]')) { cache(); return; }

    var coeur = e.target.closest('.card-wishlist .wishlist-icon');
    if (!coeur) return;
    var carte = coeur.closest('.card');
    if (!carte) return;
    // La recherche prédictive est exclue de nos ajouts de carte : elle sert à ATTEINDRE
    // un produit, pas à agir dessus.
    if (coeur.closest('#predictive-search-results-list, .quickSearchResultsBlock')) return;

    setTimeout(function () {
      montre({ type: 'wishlist', carte: carte, retire: !coeur.classList.contains('wishlist-added') });
    }, 220);
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && panneau && !panneau.hidden) cache();
  });
})();
